module.exports = __webpack_public_path__ + "img/body.619ab0f6.png";